import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { useLocalizeMessage, Table, Text } from 'libs.nucleus';
const SectionAssets = ({ onChange, assets, selectedIds = [] }) => {
    const t = useLocalizeMessage();
    const data = useMemo(() => Object.keys(assets).map((key) => {
        return {
            name: assets[key].displayName ?? '',
            asset: assets[key].asset,
        };
    }), [assets]);
    const columns = [
        {
            header: t('Name'),
            accessorKey: 'name',
            cell: (value) => {
                return value.getValue();
            },
        },
    ];
    const onRowSelectionChange = useCallback((selectedRows) => {
        const selectedAssets = selectedRows.map((row) => data[row].asset);
        onChange({
            selectedAssets,
            selectedAssetsIndex: selectedRows,
        });
    }, [data]);
    return (_jsxs("div", { className: 'flex flex-col gap-5', children: [_jsxs("div", { children: [_jsxs(Text, { size: 'sm', className: 'mb-2', children: [t('Assets selection'), _jsx("span", { className: 'text-red-500', children: "*" })] }), _jsx(Text, { size: 'xs', className: 'font-medium text-secondary', children: t('Only the assets In progress, In review and Ready are available to export') })] }), _jsx(Table, { data: data, columns: columns, labelNoResults: t('No valid assets are available for the locale you selected.'), useInternalSearch: true, hasPagination: true, initialPageSize: 10, labelSearchField: t('Search'), isSelectable: true, onRowSelectionChange: onRowSelectionChange, paginationNavigationScreenReaderLabel: t('Assets table navigation'), selectedIds: selectedIds })] }));
};
export default React.memo(SectionAssets);
